<template>
  <div id="big-boxes-health" class="big-box">
    <div class="row tight">
      <div class="col-1 text-center">
        <div>
          <div class="text-center" v-if="canEdit">
            <a @click="woundChange(-1)" class="plus-minus"><i class="fa fa-plus-circle"></i></a><br>
            <a @click="woundChange(1)" class="plus-minus"><i class="fa fa-minus-circle"></i></a>
          </div>
        </div>
      </div>
      <div class="col text-center">
        <div class="text-center">
          <strong class="primary">{{ health.wounds * -1 }}</strong>
          <nobr style="white-space: nowrap;">
            <span class="hp-slash" v-if="health.wounds">/</span><span class="hp-temp" v-if="health.wounds">{{ health.wounds }}</span>
          </nobr>
        </div>
      </div>
      <div class="col-shrink text-center">
        <span v-if="life === 'dead'" class="health dead">💀</span>
        <i v-if="life === 'incapacitated'" class="fa fa-bed health unconcious" aria-hidden="true"></i>
        <i v-if="life === 'hurt'" class="fa fa-heartbeat health hurt" aria-hidden="true"></i>
        <i v-if="life === 'full'" class="fa fa-heartbeat health full" aria-hidden="true"></i>
      </div>
      <div class="col text-center">
        <div class="text-center">
          <strong class="primary">{{ health.fatigue * -1 }}</strong>
          <nobr style="white-space: nowrap;">
            <span class="hp-slash" v-if="health.fatigue">/</span><span class="hp-temp" v-if="health.fatigue">{{ health.fatigue }}</span>
          </nobr>
        </div>
      </div>

      <div class="col-1 text-center">
        <div>
          <div class="text-center" v-if="canEdit">
            <a @click="fatigueChange(-1)" class="plus-minus"><i class="fa fa-plus-circle"></i></a><br>
            <a @click="fatigueChange(1)" class="plus-minus"><i class="fa fa-minus-circle"></i></a>
          </div>
        </div>
      </div>
    </div>

    <div class="life-bar" :class="[isHurt ? 'pink' : 'red']">
      <span :style="{ width: lifeBar + '%' }"></span>
    </div>

    <div class="topline">
      <div class="row">
        <div class="col text-center">
          <label>
            Wounds
          </label>
        </div>
        <div class="col text-center">
          <span class="cboxes">
            <i v-if="health.incapacitated" class="fa fa-fw fa-check-square" aria-hidden="true" @click="health.incapacitated = false"></i>
            <i v-else class="fa fa-fw fa-square-o c5" aria-hidden="true" @click="health.incapacitated = true"></i>
          </span>INC
        </div>
        <div class="col text-center">
          <label>
            Fatigue
          </label>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import DeathSaves from "./_DeathSaves.vue";
import HitDice from "./_HitDice.vue";
import UnderInput from "../shared/_UnderInput.vue";
import Toggle from "../shared/_Toggle.vue";

export default {
  name: "big-boxes-savage-health",
  components: {
    DeathSaves,
    HitDice,
    UnderInput,
    Toggle
  },
  data() {
    return {
      toggleState: false
    };
  },
  computed: {
    ...mapGetters({ canEdit: "characters/canEdit" }),
    ...mapState({
      ruleset: state => state.characters.current.ruleset,
      health: state => state.characters.current.defense.health,
      dead: state => state.characters.current.dead
    }),

    life() {
      let status = this.health.wounds === 0 ? "full" : "hurt";
      status = this.health.incapacitated === true ? "incapacitated" : status;
      return status;
    },

    isHurt() {
      return this.life === "hurt";
    },

    lifeBar() {
      let health = 100;
      switch (this.health.wounds) {
        case -1:
          health = 66;
          break;
        case -2:
          health = 33;
          break;
        case -3:
          health = 0;
          break;
      }
      return health;
    }
  },
  methods: {
    ...mapActions("characters", ["autoSave"]),
    woundChange(hp) {
      this.health.wounds += hp;
      if (this.health.wounds > 0) {
        this.health.wounds = 0;
      }
      if (this.health.wounds < -3) {
        this.health.incapacitated = true;
        this.health.wounds = -3;
      }
      if (this.health.wounds > -3 && this.health.fatigue > -2)
        this.health.incapacitated = false;
      this.autoSave();
    },
    fatigueChange(hp) {
      this.health.fatigue += hp;
      if (this.health.fatigue > 0) {
        this.health.fatigue = 0;
      }
      if (this.health.fatigue < -2) {
        this.health.incapacitated = true;
        this.health.fatigue = -2;
      }
      if (this.health.wounds > -3 && this.health.fatigue > -2)
        this.health.incapacitated = false;
      this.autoSave();
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../../assets/_global";

.hp-slash {
  color: $gray-600;
  font-size: 1.5em;
  line-height: 1em;
}
.hp-temp {
  color: $gray-600;
  font-size: 1em;
}
.plus-minus {
  font-size: 1.55em;
  line-height: 0.875em;
}
.mainline {
  border-bottom: 0;
}
.topline {
  font-weight: bold;
}
.health {
  margin-top: 0.15em;
  font-size: 2.5em;
  &.dead {
    margin-top: 0;
    font-size: 2.25em;
    line-height: 1.3;
  }
  &.unconcious {
    color: $gray-400;
  }
  &.bloodied {
    color: red;
  }
  &.hurt {
    color: pink;
  }
  &.full {
    color: $gray-400;
  }
}

.life-bar {
  height: 3px;
  position: relative;
  background: $gray-600;
}
.life-bar > span {
  display: block;
  height: 100%;
  background-color: $gray-600;
  position: relative;
  overflow: hidden;
}
.pink {
  background-color: pink;
}
.red {
  background-color: red;
}
.little-box {
  margin-bottom: 0.5em;
}
.cboxes {
  line-height: 1;
  font-size: 1.1em;
  cursor: pointer;
}
</style>
